import { Divider, Typography } from '@globalmed/atlas-ui';
import styles from './NavPanelHeader.module.css';
import { NavPanelInstitutionSelector } from '../NavPanelInstitutionSelector';
import { useOrganizationsStore } from '@/stores/organizations';

/**
 * Header of the plain navigation panel, shown to users without organization
 * management access. Displays the current organization's name followed by
 * the institution selector.
 * @returns The navigation panel header
 */
export const NavPanelHeader = () => {
  const currentOrganization = useOrganizationsStore(
    (state) => state.currentOrganization,
  );

  return (
    <div className={styles.wrapper}>
      {currentOrganization && (
        <>
          <Typography
            as="span"
            fontWeight={700}
            fontSize="18px"
            className={styles.header}
          >
            {currentOrganization.name}
          </Typography>
          <Divider sx={{ marginBottom: '16px' }} />
        </>
      )}
      <NavPanelInstitutionSelector />
    </div>
  );
};
